export default __webpack_public_path__ + "static/media/bookShop1.66fc4632.PNG";